export default {
    baseURL: 'https://pokeapi.co/api/v2/'
}